import { api } from "./api";

// Small shared GET cache: coalesces the SAME endpoint requested by several
// components at once (e.g. /me/nav-badges polled by AppShell + HeaderChatButton
// + NavigationDrawer) into ONE network call, and serves a short-lived cache so
// repeated polls don't each pay a transatlantic round-trip.
const cache = new Map();     // url -> { at, data }
const inflight = new Map();  // url -> Promise

export const sharedGet = (url, { ttl = 30000, force = false } = {}) => {
  const now = Date.now();
  if (!force) {
    const c = cache.get(url);
    if (c && now - c.at < ttl) return Promise.resolve(c.data);
    if (inflight.has(url)) return inflight.get(url);
  } else {
    inflight.delete(url);
  }
  const p = api
    .get(url)
    .then(({ data }) => {
      cache.set(url, { at: Date.now(), data });
      if (inflight.get(url) === p) inflight.delete(url);
      return data;
    })
    .catch((e) => {
      if (inflight.get(url) === p) inflight.delete(url);
      throw e;
    });
  inflight.set(url, p);
  return p;
};

export const invalidateShared = (url) => { cache.delete(url); inflight.delete(url); };
